import { createSlice, PayloadAction } from "@reduxjs/toolkit";


export type CleaningState = {
  isExpandSelectedZone: boolean,
  isExpandUnselectedZone: boolean
}

const initialState: CleaningState = {
  isExpandSelectedZone: false,
  isExpandUnselectedZone: false,
}

export const cleaningSlice = createSlice({
  name: "cleaning",
  initialState,
  reducers: {
    setIsExpandSelectedZone: (state, action: PayloadAction<{value: boolean}>) => {
      state.isExpandSelectedZone = action.payload.value
    },
    setIsExpandUnselectedZone: (state, action: PayloadAction<{value: boolean}>) => {
      state.isExpandUnselectedZone = action.payload.value
    }
  }
})

export const {
  setIsExpandSelectedZone,
  setIsExpandUnselectedZone
} = cleaningSlice.actions

export default cleaningSlice.reducer